import axios from "axios";
import axiosInstance from "./axiosInstance";

const queryString = require("query-string");

class FormularioApi {

  cancelTokens = {
    getFormularios: null,
    getFormulario: null,
    setFormulario: null,
    destroyFormulario: null,
  };

  isCancel(exceptionThrown) {
    return axios.isCancel(exceptionThrown);
  }

  async designarFormulario(formularioId, servidorIds) {
    const payload = {
      servidor_ids: servidorIds,
    };

    const { data } = await axiosInstance.post(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/formularios/${formularioId}/designar`,
      payload
    );
    return data;
  }

  async getRespondentes(formularioId) {
    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/formularios/${formularioId}/respondentes`
    );
    return data;
  }

  async getRespostasPorServidor(formularioId, servidorId) {
    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/formularios/${formularioId}/respostas_por_servidor/${servidorId}`
    );
    return data;
  }

  async getRespostasParaEdicao(formularioId, servidorId) {
    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/formularios/${formularioId}/respostas_para_edicao/${servidorId}`
    );
    return data;
  }
  async getUnidades() {
    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/unidades`
    );
    return data;
  }

  async getFormularios({ page = 1, qtd_por_pagina, titulo, id_unidade, data_inicio, data_final }) {
    const query = queryString.stringify({
      page,
      qtd_por_pagina,
      titulo,
      id_unidade,
      data_inicio,
      data_final,
    });

    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.getFormularios = source;
  
    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/formularios?${query}`,
      {
        cancelToken: source.token,
      }
    );

    this.cancelTokens.getFormularios = null;
    return data;
  }

  async getFormulario(formularioId) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.getFormulario = source;

    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/formularios/${formularioId}`,
      {
        cancelToken: source.token,
      }
    );

    this.cancelTokens.getFormulario = null;
    return data;
  }

  async destroyFormulario(formularioId) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.destroyFormulario = source;

    const { data } = await axiosInstance.delete(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/formularios/${formularioId}`,
      {
        cancelToken: source.token,
      }
    );

    this.cancelTokens.destroyFormulario = null;
    return data;
  }

  async setFormulario(dadosParaSalvar) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.setFormulario = source;
    
    const formularioId = dadosParaSalvar.formulario.id;

    if (formularioId) {
      
      const { data } = await axiosInstance.put(
        `${process.env.VUE_APP_BASE_API_URL}/api/v1/formularios/${formularioId}`,
        dadosParaSalvar,
        {
          cancelToken: source.token,
        }
      );
      this.cancelTokens.setFormulario = null;
      return data;
    } else {
      
      const { data } = await axiosInstance.post(
        `${process.env.VUE_APP_BASE_API_URL}/api/v1/formularios`,
        dadosParaSalvar,
        {
          cancelToken: source.token,
        }
      );
      this.cancelTokens.setFormulario = null;
      return data;
    }
  }
  async salvarRespostas(formularioId, respostas) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    const payload = { respostas };

    const { data } = await axiosInstance.post(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/formularios/${formularioId}/respostas_formulario`,
      payload,
      {
        cancelToken: source.token,
      }
    );
    return data;
  }
  async atualizarRespostas(formularioId, servidorId, respostas) {
    const payload = { respostas };

    
    const { data } = await axiosInstance.put(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/formularios/${formularioId}/respostas_por_servidor/${servidorId}`,
      payload
    );
    
    return data;
  }

  gerarRelatorioPdf(formularioId) {
    // Usa 'post' como definido na rota e 'blob' para que o navegador
    // entenda que estamos esperando um arquivo como resposta.
    return axiosInstance.post(`${process.env.VUE_APP_BASE_API_URL}/api/v1/formularios/${formularioId}/gerar_relatorio_pdf`, {}, {
      responseType: 'blob'
    });
  }
}

export default FormularioApi;